module.exports = __webpack_public_path__ + "img/13.cff6998e.png";